import { Dropdown } from 'antd';
import React, { useState } from 'react'
import { MdFilterAlt } from 'react-icons/md';




const Filters = ({items, selectedFilters, setSelectedFilters}) => {
  // const [selectedFilters, setSelectedFilters] = useState([]);

  const onChangeSelectedFilter = (item, key, keyPath, e) => setSelectedFilters(item.selectedKeys);

  return (
    <div>
      <Dropdown
        menu={{
          onSelect: onChangeSelectedFilter,
          onDeselect: onChangeSelectedFilter,
          items: items, 
          selectable: true, 
          multiple: true, 
          selectedKeys: selectedFilters
        }} 
        className='flex items-center w-max'
        >
        <span><MdFilterAlt />Filters</span>
      </Dropdown>
    </div>
  )
}

export default Filters